import {popupInfoDialog} from "../../library/info-dialog";
import {trackEvent} from "../../library/analytics";
import {addShowMoreDescriptionBtn, showMoreDescription} from "./show-more-description";
import {uploadImage} from "./upload-image";
import {addToCartAjax} from "./add-to-cart-personalized";
import {showShoppingCart} from "./product-shopping-cart";

$(document).ready(function() {
    $('body').on('click', '.designer-plan:not(.selected-plan):not(:has(.btn-hire-data.disabled))', function() {
        selectPlan($(this).find('.btn-hire-data'));
    });
    $('.btn-hire-data:not(.disabled)').click(function() {
        selectPlan($(this));
    });

    $('.plans-container .plan-box').hover(
        function() {
            $(this).siblings().each(function() {
                $(this).find('.designer-plan').first().addClass('unhighlighted');
            });
            $(this).find('.designer-plan').first().addClass('highlighted');
        },
        function () {
            $(this).find('.designer-plan').first().removeClass('highlighted');
            $(this).siblings().each(function() {
                $(this).find('.designer-plan').first().removeClass('unhighlighted');
            });
        }
    );

    $('.upload-file').on('change', function (event) {
        let files = event.target.files,
            routeInput = $(this).siblings('.file-route'),
            displayInput = $(this).siblings('.file-display');

        uploadImage(
            files,
            {prefix: 'designer'},
            function(data) {
                routeInput.val(data.fileInfo.file);
                displayInput.val(data.fileInfo.originalName);
                trackEvent('Designer', 'Upload', 'ok');
            },
            function(data) {
                popupInfoDialog(data.error);
                trackEvent('Designer', 'Upload', 'error');
            }
        );
    });

    $('.plan-form').submit(function(e){

        e.preventDefault();
        let productId = $(this).parent().find("input[name='productId']").val();
        let rate = $(this).parent().find("input[name='rateId']").val();
        let noteFile1 = $(this).parent().find("input[name='file-route1']").val();
        let noteFile2 = $(this).parent().find("input[name='file-route2']").val();
        let notes = $(this).parent().find("textarea[name='notes']").val();
        let plan = $(this).closest('.designer-plan').find('.plan-title').text()

        let data = {
            productId: productId,
            quantity: 1,
            isLocked: true,
            options: {
                noteFile1: noteFile1,
                noteFile2: noteFile2,
                size: rate,
                notes: notes
            }
        };

        if (noteFile1 != "") {
            data.options.personalizedImage = noteFile1;
        }
        if (document.referrer.indexOf(location.protocol + "//" + location.host) === 0) data.options.referrer = document.referrer;

        addToCartAjax(
            data,
            function (data) {
                $(this).parent().find("textarea[name='notes']").val("");
                showShoppingCart();
                closePlans();
                $(".plan-form").trigger('reset');
                trackEvent('Designer', 'AddToCart', plan);
            },
            function (data) {
                popupInfoDialog(data.errorMessage);
            }
        );
    })

    $(document).on('click', '.show-more-description-btn', function () {
        showMoreDescription(this);
    });
    addShowMoreDescriptionBtn();

    let notesTimeOut;

    $("textarea[name='notes']").keydown(function() {
        clearTimeout(notesTimeOut);
        notesTimeOut = setTimeout(function(){
            trackEvent('Designer', 'NotesPlan', '');
        }, 1000);
    })
});

function selectPlan(btn) {
    closePlans();
    let hireDataContainer = btn.siblings('.hire-data');
    let planContainer = btn.parents('.designer-plan');
    $('.selected-plan').removeClass('selected-plan');
    planContainer.addClass('selected-plan').removeClass('highlighted');

    $('.plans-container .plan-box').off('mouseenter mouseleave');
    $('.unhighlighted').removeClass('unhighlighted');

    setPlanHeight(planContainer);
    setTimeout(function () {
        btn.slideUp('fast');
        hireDataContainer.slideDown('fast');
    }, 250);

    trackEvent('Designer', 'SelectPlan', btn.closest('.designer-plan').find('.plan-title').text());
}

function setPlanHeight(planContainer) {
    let titleHeight = planContainer.find('.plan-title').outerHeight(true),
        descriptionHeight = planContainer.find('.plan-description').outerHeight(true),
        priceHeight = planContainer.find('.plan-price').outerHeight(true),
        servicesHeight = planContainer.find('.plan-services').outerHeight(true),
        hireBtnHeight = planContainer.find('.hire-plan').outerHeight(true),
        hireDataHeight = planContainer.find('.hire-data').outerHeight(true),
        extra = 20;

    let height = titleHeight + descriptionHeight + priceHeight + servicesHeight + hireBtnHeight + hireDataHeight + extra;
    planContainer.css('min-height', height + 'px');
}

function closePlans() {
    let hireDataContainer = $('.hire-data:visible');
    if (hireDataContainer.length) {
        let planContainer = hireDataContainer.parents('.designer-plan'),
            btnHireData = planContainer.find('.btn-hire-data');

        hireDataContainer.slideUp('fast');
        btnHireData.slideDown('fast');
        setTimeout(function () {
            planContainer.css('min-height', '');
        }, 250);
    }
}